import Repository from '../Repository';
import { useToast } from 'vue-toastification';

const resource = '/invitation';
const toast = useToast();

export default {
	show(uuid) {
		return Repository.get(`${resource}/${uuid}`);
	},
	accept(uuid) {
		return Repository.put(`${resource}/${uuid}/accept`).then((response) => {
			toast.success(`Invitación aceptada.`);
			return response;
		});
	},
	reject(uuid) {
		return Repository.put(`${resource}/${uuid}/reject`).then((response) => {
			toast.success(`Invitación rechazada.`);
			return response;
		});
	}
}